import Utils from "../../../services/utils/utils";
import {generatePath} from "react-router";
import {UserHomepageViewMode} from "../../../../ui/containers/user-homepage/models";

/**
 * The new routes of the application
 */
export const routes = {
    salesOld: {
        salesOrder: '/sales/salesOrders' as const,
        backOrder: '/sales/backOrders' as const,
    } as const,
    customerSalesOld: {
        salesOrder: '/customer/:customerId/sales/salesOrders' as const,
        salesOrderDetails: '/customer/:customerId/sales/salesOrders/:orderId' as const,
        backOrder: '/customer/:customerId/sales/backOrders' as const,
        backOrderDetails: '/customer/:customerId/sales/backOrders/:orderId' as const,
    } as const,
    warrantyAndReturnOld: {
        base: '/warrantyAndReturn' as const,
        requests: '/warrantyAndReturn/requests' as const,
        single: '/warrantyAndReturn/requests/:requestId' as const,
        settings: {
            statuses: "/warrantyAndReturn/settings/statuses" as const,
            process: '/warrantyAndReturn/settings/process' as const,
        } as const,
    } as const,

    landing: '/' as const,
    versions: '/versionHistory' as const,
    test: '/test/:userId?' as const,
    auth: {
        base: '/auth' as const,
        redirect: '/auth/redirect' as const,
        logout: '/auth/logout' as const,
        login: '/auth/login' as const,
    } as const,
    operatorProfile: "/operator-profile" as const,
    partnerProfile: "/partner-profile" as const,
    error: {
        base: '/error' as const,
        notFound: '/error/not-found' as const,
        accessDenied: '/error/access-denied' as const,
        serverError: '/error/server-error' as const,
        serverErrorForSection: '/error/sectional-server-error' as const,
        accessDeniedForSection: '/error/sectional-access-denied' as const,
    } as const,
    public: {
        phoneStripeCardSetup: "/phone-stripe-card-setup" as const,
        phoneStripeCardSetupClientSide: "/phone-stripe-card-setup-client-side" as const,
    } as const,
    print: {
        base: '/print' as const,
        quote: '/print/:customerId/orders/quote/:orderId' as const,
        salesOrder: '/print/:customerId/orders/sales-order/:orderId' as const,
        invoice: '/print/:customerId/orders/invoice/:orderId' as const,
        credit: '/print/:customerId/orders/credit/:orderId' as const,
        partSupport: '/print/warranty-and-return/requests/:requestId' as const,
        customerOutstandingStatement: '/print/outstanding-statement/:customerId' as const,
        purchaseOrder: '/print/vendor/:vendorId/purchases/orders/:orderId' as const,
        purchaseHistory: '/print/vendor/:vendorId/purchases/history/:historyId' as const,
    } as const,
    printing: {
        base: '/printing' as const,
        printHub: '/printing/hub' as const,
        printLabels: '/printing/product-labels' as const,
        printCatalogue: '/printing/product-catalogue' as const,
        printBrochure: '/printing/product-brochure' as const,
        printPackingList: '/printing/packing-list' as const,
    } as const,
    dashboard: '/dashboard' as const,
    notificationManagement: '/received-notification-management' as const,
    lookup: {
        base: '/lookup-v2' as const,
        search: '/lookup-v2/search' as const,
        compare: '/lookup-v2/compare' as const,
        productInformation: '/lookup-v2/product-information/:partNumber' as const,
        competitorPriceReport: '/lookup-v2/competitor-price-report' as const,
    } as const,
    warrantyAndReturn: {
        base: '/warranty-and-return' as const,
        requests: '/warranty-and-return/requests' as const,
        single: '/warranty-and-return/requests/:requestId' as const,
        settings: {
            statuses: "/warranty-and-return/settings/statuses" as const,
            process: '/warranty-and-return/settings/process' as const,
        } as const,
    } as const,
    ncr: {
        base: '/ncr' as const,
        reports: '/ncr/reports' as const,
        single: '/ncr/reports/:reportId' as const,
        settings: '/ncr/settings/:tab?' as const,
        notes: '/ncr/notes' as const,
        tasks: '/ncr/tasks' as const,
    } as const,
    forms: {
        base: '/forms' as const,
        list: '/forms/list' as const,
        responses: '/forms/responses' as const,
    } as const,
    support: {
        base: '/support' as const,
        contactUsMessages: '/support/contact-us-messages' as const,
    } as const,
    bizPoint: {
        base: '/biz-point' as const,
        loyalty: {
            base: '/biz-point/loyalty' as const,
            dashboard: '/biz-point/loyalty/dashboard' as const,
            buy: '/biz-point/loyalty/buy' as const,
            rules: '/biz-point/loyalty/rules' as const,
            customers: '/biz-point/loyalty/customers' as const,
            settings: '/biz-point/loyalty/settings' as const,
        } as const,
        admin: {
            base: '/biz-point/admin' as const,
            reviewQueue: '/biz-point/admin/review-queue' as const,
            walletOperations: '/biz-point/admin/wallet-operations' as const,
            /** @deprecated Use walletOperations — kept for redirects */
            manualAdjustment: '/biz-point/admin/manual-adjustment' as const,
            businessConfig: '/biz-point/admin/business-config' as const,
            liabilityReport: '/biz-point/admin/liability-report' as const,
            auditLog: '/biz-point/admin/audit-log' as const,
            purchaseConfirm: '/biz-point/admin/purchase-confirm' as const,
            /** @deprecated Use walletOperations — kept for redirects */
            walletSuspend: '/biz-point/admin/wallet-suspend' as const,
        } as const,
    } as const,
    drivers: '/drivers' as const,
    reports: '/reports' as const,
    content: {
        base: '/content' as const,
        blogs: {
            base: '/content/blogs' as const,
            list: '/content/blogs/list' as const,
            single: '/content/blogs/:slug' as const,
        } as const,
        videos: {
            base: '/content/videos' as const,
            list: '/content/videos/list' as const,
            single: '/content/videos/:slug' as const,
        } as const,
    } as const,
    customers: {
        base: '/customers' as const,
        list: '/customers/list' as const,
        members: {
            base: '/customers/members' as const,
            activeMembers: '/customers/members/active-members' as const,
            inactiveMembers: '/customers/members/inactive-members' as const,
            passiveMembers: '/customers/members/passive-members' as const,
        } as const,
    } as const,
    operators: {
        base: '/operators' as const,
        list: '/operators/list' as const,
        groups: {
            base: '/operators/groups' as const,
            single: '/operators/groups/:groupId' as const,
        } as const,
        dashboards: {
            base: '/operators/dashboards' as const,
            single: '/operators/dashboards/:groupId' as const,
        } as const,
    } as const,
    sales: {
        base: '/sales' as const,
        quotes: '/sales/quotes' as const,
        salesOrder: '/sales/sales-orders' as const,
        backOrder: '/sales/back-orders' as const,
        invoices: '/sales/invoices' as const,
        credits: '/sales/credits' as const,
        promotions: {
            base: '/sales/promotions' as const,
            list: '/sales/promotions/list' as const,
            single: '/sales/promotions/:promotionId' as const,
        },
    } as const,
    salesPerson: {
        base: "/sales-person" as const,
        dashboard: '/sales-person/dashboard' as const,
    } as const,
    accounting: {
        base: '/accounting' as const,
        invoices: '/accounting/invoices' as const,
        onlinePaymentTransactions: '/accounting/online-payment-transactions' as const,
        accountReceivable: '/accounting/accountReceivable' as const,
    } as const,
    userNotifications: {
        base: '/notifications' as const,
        list: '/notifications/list' as const,
        accessLevels: '/notifications/access-levels' as const,
        subscriptions: '/notifications/system-subscriptions' as const,
    } as const,
    userPlatform: {
        base: '/user-platform' as const,
        list: '/user-platform/list' as const,
        liveHomepages: '/user-platform/live-home-pages' as const,
        phoneHomepage: "/user-platform/phone-homepage/:versionId/:viewMode" as const,
        webHomepage: "/user-platform/web-homepage/:versionId/:viewMode" as const,
        themeManagement: {
            phone: '/user-platform/theme-management/phone-homepage' as const,
            web: '/user-platform/theme-management/web-homepage' as const,
        } as const,
        bannerManagement: "/user-platform/banner-management" as const,
        contentManagement: "/user-platform/content-management" as const,
        surveys: {
            base: '/user-platform/surveys' as const,
            list: '/user-platform/surveys/list' as const,
            surveyPreview: '/user-platform/surveys/single/:surveyId' as const,
        } as const,
        dynamicPages: {
            base: '/user-platform/dynamic-pages' as const,
            list: '/user-platform/dynamic-pages/list' as const,
            single: '/user-platform/dynamic-pages/single/:pageId' as const,
        } as const,
    } as const,
    settings: {
        base: '/settings' as const,
        organization: '/settings/organization' as const,
        personal: '/settings/personal' as const,
        industries: '/settings/industries' as const,
        salesPersons: '/settings/sales-persons' as const,
        productProperties: '/settings/product-properties' as const,
        territories: '/settings/territories' as const,
        partnersManagement: '/settings/partners-management' as const,
        taxes: {
            base: '/settings/taxes' as const,
            list: '/settings/taxes/list' as const,
            regionTaxes: '/settings/taxes/default-provincial-taxes' as const,
        } as const,
        giftCards: {
            base: '/settings/giftCards' as const,
            list: '/settings/giftCards/list' as const,
            categories: '/settings/giftCards/categories' as const,
        } as const,
        priceMatrix: {
            base: "/settings/tier-pricing" as const,
            list: "/settings/tier-pricing/list" as const,
            customers: "/settings/tier-pricing/customers" as const,
        } as const,
        export: '/settings/export' as const,
        import: '/settings/import' as const,
        regions: '/settings/regions' as const,
        priceLevels: '/settings/price-levels' as const,
        partnership: '/settings/partnership' as const,
    } as const,
    damageControl: {
        base: '/damage-control' as const,
        missingProducts: '/damage-control/manage-missing-public-products' as const,
        transactions: '/damage-control/transactions' as const,
    } as const,
    products: {
        base: '/products' as const,
        list: '/products/list' as const,
        single: '/products/list/:id/:tab?' as const,
        categoryManagement: '/products/category-management' as const,
        codeTypes: '/products/code-types' as const,
        shareRules: '/products/share-rules' as const,
        manageProperties: '/products/manage-properties' as const,
        tags: {
            list: '/products/tags/list' as const,
            single: '/products/tags/list/:id' as const,
        } as const,
        relationTypes: '/products/relation-types' as const,
        manageSuggestions: {
            base: '/products/manage-suggestions' as const,
            application: '/products/manage-suggestions/application' as const,
            technical: '/products/manage-suggestions/technical' as const,
        } as const,
        productFastConnection: '/products/fast-connection' as const,
        bulkPriceChange: {
            base: '/products/bulk-price-change' as const,
            dashboard: '/products/bulk-price-change/dashboard' as const,
            newBulkPrice: '/products/bulk-price-change/create-new/:id' as const,
            report: '/products/bulk-price-change/report/:id' as const,
        } as const,
    } as const,
    inventory: {
        base: '/inventory' as const,
        inventoryAdjustment: {
            base: '/inventory/inventory-adjustment' as const,
            list: '/inventory/inventory-adjustment/list' as const,
            items: '/inventory/inventory-adjustment/items' as const,
            report: '/inventory/inventory-adjustment/report' as const,
            single: '/inventory/inventory-adjustment/single/:id' as const,
            bulkAvailabilityChange: '/inventory/inventory-adjustment/bulk-availability-change' as const,
        } as const,
        inventoryTransfer: {
            base: '/inventory/inventory-transfer' as const,
            list: '/inventory/inventory-transfer/list' as const,
            single: '/inventory/inventory-transfer/single/:id' as const,
            // legacy — keep until batches, history-items, returns, and post-transfer stepper ship
            batches: '/inventory/inventory-transfer/batches' as const,
            batchInformation: '/inventory/inventory-transfer/batches/:id' as const,
            postTransfer: '/inventory/inventory-transfer/post-transfer/:id' as const,
            returnInformation: '/inventory/inventory-transfer/return/:fromWarehouseId/:toWarehouseId' as const,
            historyList: '/inventory/inventory-transfer/history-list' as const,
            historyItems: '/inventory/inventory-transfer/history-items' as const,
            historyInformation: '/inventory/inventory-transfer/history/:id' as const,
        } as const,
        availabilityThresholds: '/inventory/availability-thresholds' as const,
    } as const,
    shippingFees: {
        base: '/shipping-fees' as const,
        list: '/shipping-fees/list' as const,
        settings: '/shipping-fees/settings' as const,
        companies: '/shipping-fees/freight-companies' as const,
        reports: '/shipping-fees/reports' as const,
        /** @deprecated Use shippingRates.regionRates — kept for legacy redirects */
        regionRates: '/shipping-fees/region-rates' as const,
        shippingRates: {
            base: '/shipping-fees/shipping-rates' as const,
            regionRates: '/shipping-fees/shipping-rates/region-rates' as const,
            productFlatRates: '/shipping-fees/shipping-rates/product-flat-rates' as const,
        } as const,
    } as const,
    purchase: {
        base: '/purchase' as const,
        /** @deprecated Prefer `orders`; kept for back-compat redirect. */
        list: "/purchase/list" as const,
        orders: "/purchase/orders" as const,
        history: "/purchase/history" as const,
        planningDetails: "/purchase/planning-list/:id" as const,
        planningList: "/purchase/planning-list" as const,
    } as const,
    vendors: '/vendors' as const,
    vendor: {
        base: '/vendor/:vendorId' as const,
        accountInfo: '/vendor/:vendorId/account-info' as const,
        notes: '/vendor/:vendorId/notes' as const,
        products: '/vendor/:vendorId/products' as const,
        purchases: {
            base: '/vendor/:vendorId/purchases' as const,
            orders: {
                base: '/vendor/:vendorId/purchases/orders' as const,
                single: '/vendor/:vendorId/purchases/orders/:orderId' as const,
            } as const,
            history: {
                base: '/vendor/:vendorId/purchases/history' as const,
                single: '/vendor/:vendorId/purchases/history/:historyId' as const,
            } as const,
        } as const,
    } as const,
    notebook: '/notebook' as const,
    analytics: {
        base: '/analytics' as const,
        systemDashboards: '/analytics/system-dashboards' as const,
        systemReports: '/analytics/system-reports' as const,
        lookup: {
            base: '/analytics/lookup' as const,
            dashboard: '/analytics/lookup/dashboard' as const,
            logs: '/analytics/lookup/logs' as const,
        } as const,
        lostSales: {
            base: '/analytics/lost-sales' as const,
            dashboard: '/analytics/lost-sales/dashboard' as const,
            logs: '/analytics/lost-sales/logs' as const,
        } as const,
        dashboards: '/analytics/dashboards' as const,
        logs: {
            base: '/analytics/logs' as const,
            lookup: '/analytics/logs/lookup' as const,
            lostSales: '/analytics/logs/lost-sales' as const,
        } as const,
    } as const,
    customer: {
        base: '/customer/:customerId' as const,
        generalInformation: {
            base: '/customer/:customerId/general-info' as const,
            profile: '/customer/:customerId/general-info/profile' as const,
            addresses: '/customer/:customerId/general-info/addresses' as const,
            loginLogs: '/customer/:customerId/general-info/login-logs' as const,
            paymentMethods: '/customer/:customerId/general-info/payment-methods' as const,
            promotions: '/customer/:customerId/general-info/promotions' as const,
        } as const,
        priceMatrix: '/customer/:customerId/tier-pricing' as const,
        notes: '/customer/:customerId/notes' as const,
        accounting: {
            base: '/customer/:customerId/accounting' as const,
            availableCredits: '/customer/:customerId/accounting/available-credits' as const,
            accountReceivableTransactions: '/customer/:customerId/accounting/account-receivable-transactions' as const,
            invoices: {
                base: '/customer/:customerId/accounting/invoices' as const,
                single: '/customer/:customerId/accounting/invoices/:orderId' as const,
            },
        } as const,
        sales: {
            base: '/customer/:customerId/sales' as const,
            quotes: {
                base: '/customer/:customerId/sales/quotes' as const,
                single: '/customer/:customerId/sales/quotes/:orderId' as const,
            } as const,
            salesOrder: {
                base: '/customer/:customerId/sales/sales-orders' as const,
                single: '/customer/:customerId/sales/sales-orders/:orderId' as const,
            } as const,
            backOrder: {
                base: '/customer/:customerId/sales/back-orders' as const,
                single: '/customer/:customerId/sales/back-orders/:orderId' as const,
            } as const,
            invoices: {
                base: '/customer/:customerId/sales/invoices' as const,
                single: '/customer/:customerId/sales/invoices/:orderId' as const,
            } as const,
            credits: {
                base: '/customer/:customerId/sales/credits' as const,
                single: '/customer/:customerId/sales/credits/:orderId' as const,
            } as const,
            shoppingCart: '/customer/:customerId/sales/shopping-cart' as const,
        } as const,
        cardSummary: {
            creditCards: "/customer/:customerId/card-summary/credit-cards/:id" as const,
            giftCards: "/customer/:customerId/card-summary/gift-cards/:id" as const,
        } as const,
        shippingFees: {
            base: '/customer/:customerId/shipping-fees' as const,
            list: '/customer/:customerId/shipping-fees/list' as const,
            settings: '/customer/:customerId/shipping-fees/settings' as const,
        } as const,
        forms: {
            responses: '/customer/:customerId/forms/responses' as const,
        } as const,
    } as const,
}

/**
 * The new routing function to replace the placeHolders in the url
 */
export const routeFunctions = {
    print: {
        quote: (customerId, orderId) => generatePath(routes.print.quote, {customerId: customerId ?? 0, orderId: orderId ?? 0}),
        salesOrder: (customerId, orderId) => generatePath(routes.print.salesOrder, {customerId: customerId ?? 0, orderId: orderId ?? 0}),
        invoice: (customerId, orderId) => generatePath(routes.print.invoice, {customerId: customerId ?? 0, orderId: orderId ?? 0}),
        credit: (customerId, orderId) => generatePath(routes.print.credit, {customerId: customerId ?? 0, orderId: orderId ?? 0}),
        partSupport: (requestId) => generatePath(routes.print.partSupport, {requestId: requestId ?? 0}),
        customerOutstandingStatement: (customerId) => generatePath(routes.print.customerOutstandingStatement, {customerId: customerId ?? 0}),
        purchaseOrder: (vendorId, orderId) => generatePath(routes.print.purchaseOrder, {vendorId: vendorId ?? 0, orderId: orderId ?? 0}),
        purchaseHistory: (vendorId, historyId) => generatePath(routes.print.purchaseHistory, {vendorId: vendorId ?? 0, historyId: historyId ?? 0}),
    } as const,
    lookup: {
        single: (partNumber) => generatePath(routes.lookup.productInformation, {partNumber: encodeURIComponent(partNumber)}),
    } as const,
    warrantyAndReturn: {
        single: (requestId) => generatePath(routes.warrantyAndReturn.single, {requestId: requestId ?? 0}),
    } as const,
    ncr: {
        single: (reportId) => generatePath(routes.ncr.single, {reportId: reportId ?? 0}),
        settings: (tab) => generatePath(routes.ncr.settings, {tab: tab}),
    } as const,
    forms: {
        list: () => routes.forms.list,
        responses: () => routes.forms.responses,
    } as const,
    content: {
        blogs: {
            single: (slug) => generatePath(routes.content.blogs.single, {slug: encodeURIComponent(slug ?? '')}),
        },
        videos: {
            single: (slug) => generatePath(routes.content.videos.single, {slug: encodeURIComponent(slug ?? '')}),
        },
    } as const,
    operators: {
        groups: {
            single: (groupId) => generatePath(routes.operators.groups.single, {groupId: groupId ?? 0}),
        },
        dashboards: {
            single: (groupId) => generatePath(routes.operators.dashboards.single, {groupId: groupId ?? 0}),
        },
    } as const,
    userPlatform: {
        phoneHomepage: (versionId, viewMode) => generatePath(routes.userPlatform.phoneHomepage, {
            versionId: versionId ?? 0,
            viewMode: viewMode ?? UserHomepageViewMode.preview
        }),
        webHomepage: (versionId, viewMode) => generatePath(routes.userPlatform.webHomepage, {
            versionId: versionId ?? 0,
            viewMode: viewMode ?? UserHomepageViewMode.preview
        }),
        surveys: {
            single: (surveyId) => generatePath(routes.userPlatform.surveys.surveyPreview, {surveyId: surveyId ?? 0}),
        },
        dynamicPages: {
            single: (pageId) => generatePath(routes.userPlatform.dynamicPages.single, {pageId: pageId ?? 0}),
        },
    } as const,
    settings: {
        promotion: {
            single: (promotionId) => generatePath(routes.sales.promotions.single, {promotionId: promotionId ?? 0}),
        }
    } as const,
    products: {
        single: (id, tab) => generatePath(routes.products.single, {id: id ?? 0, tab: tab ? encodeURIComponent(tab) : undefined}),
        tags: {
            single: (id) => generatePath(routes.products.tags.single, {id: id ?? 0}),
        },
        bulkPriceChange: {
            report: (id, autoStart = false) => generatePath(routes.products.bulkPriceChange.report, {id: id ?? 0}).concat(autoStart ? "?autoStart=true" : ''),
            newBulkPrice: (id) => generatePath(routes.products.bulkPriceChange.newBulkPrice, {id: id ?? 0}),
        },
    } as const,
    inventory: {
        inventoryAdjustment: {
            single: (id) => generatePath(routes.inventory.inventoryAdjustment.single, {id: id ?? 0}),
        },
        inventoryTransfer: {
            single: (id) => generatePath(routes.inventory.inventoryTransfer.single, {id: id ?? 0}),
            // legacy
            batchInformation: (id) => generatePath(routes.inventory.inventoryTransfer.batchInformation, {id: id ?? 0}),
            returnInformation: (fromWarehouseId, toWarehouseId) => generatePath(routes.inventory.inventoryTransfer.returnInformation, {
                fromWarehouseId: fromWarehouseId ?? 0,
                toWarehouseId: toWarehouseId ?? 0,
            }),
            postTransfer: (id) => generatePath(routes.inventory.inventoryTransfer.postTransfer, {id: id ?? 0}),
            historyInformation: (id) => generatePath(routes.inventory.inventoryTransfer.historyInformation, {id: id ?? 0}),
        },
    } as const,
    purchase: {
        planningDetails: (id) => generatePath(routes.purchase.planningDetails, {id: id ?? 0}),
    } as const,
    vendor: {
        base: (vendorId) => generatePath(routes.vendor.base, {vendorId: vendorId ?? 0}),
        accountInfo: (vendorId) => generatePath(routes.vendor.accountInfo, {vendorId: vendorId ?? 0}),
        notes: (vendorId) => generatePath(routes.vendor.notes, {vendorId: vendorId ?? 0}),
        products: (vendorId) => generatePath(routes.vendor.products, {vendorId: vendorId ?? 0}),
        purchases: {
            base: (vendorId) => generatePath(routes.vendor.purchases.base, {vendorId: vendorId ?? 0}),
            orders: {
                base: (vendorId) => generatePath(routes.vendor.purchases.orders.base, {vendorId: vendorId ?? 0}),
                single: (vendorId, orderId) => generatePath(routes.vendor.purchases.orders.single, {
                    vendorId: vendorId ?? 0,
                    orderId: orderId ?? 0,
                }),
            },
            history: {
                base: (vendorId) => generatePath(routes.vendor.purchases.history.base, {vendorId: vendorId ?? 0}),
                single: (vendorId, historyId) => generatePath(routes.vendor.purchases.history.single, {
                    vendorId: vendorId ?? 0,
                    historyId: historyId ?? 0,
                }),
            },
        },
    } as const,
    customer: {
        base: (customerId) => generatePath(routes.customer.base, {customerId: customerId ?? 0}),
        generalInformation: {
            profile: (customerId) => generatePath(routes.customer.generalInformation.profile, {customerId: customerId ?? 0}),
            addresses: (customerId) => generatePath(routes.customer.generalInformation.addresses, {customerId: customerId ?? 0}),
            loginLogs: (customerId) => generatePath(routes.customer.generalInformation.loginLogs, {customerId: customerId ?? 0}),
            paymentMethods: (customerId) => generatePath(routes.customer.generalInformation.paymentMethods, {customerId: customerId ?? 0}),
            promotions: (customerId) => generatePath(routes.customer.generalInformation.promotions, {customerId: customerId ?? 0}),
        },
        priceMatrix: (customerId) => generatePath(routes.customer.priceMatrix, {customerId: customerId ?? 0}),
        notes: (customerId) => generatePath(routes.customer.notes, {customerId: customerId ?? 0}),
        accounting: {
            base: (customerId) => generatePath(routes.customer.accounting.base, {customerId: customerId ?? 0}),
            availableCredits: (customerId) => generatePath(routes.customer.accounting.availableCredits, {customerId: customerId ?? 0}),
            accountReceivableTransactions: (customerId) => generatePath(routes.customer.accounting.accountReceivableTransactions, {customerId: customerId ?? 0}),
            invoices: {
                base: (customerId) => generatePath(routes.customer.accounting.invoices.base, {customerId: customerId ?? 0}),
                single: (customerId, invoiceId) => generatePath(routes.customer.accounting.invoices.single, {
                    customerId: customerId,
                    orderId: invoiceId
                }),
            },
        },
        sales: {
            base: (customerId) => generatePath(routes.customer.sales.base, {customerId: customerId ?? 0}),
            quotes: {
                base: (customerId) => generatePath(routes.customer.sales.quotes.base, {customerId: customerId ?? 0}),
                single: (customerId, orderId) => generatePath(routes.customer.sales.quotes.single, {
                    customerId: customerId ?? 0,
                    orderId: orderId ?? 0
                }),
            },
            salesOrder: {
                base: (customerId) => generatePath(routes.customer.sales.salesOrder.base, {customerId: customerId ?? 0}),
                single: (customerId, orderId) => generatePath(routes.customer.sales.salesOrder.single, {
                    customerId: customerId ?? 0,
                    orderId: orderId ?? 0
                }),
            },
            backOrder: {
                base: (customerId) => generatePath(routes.customer.sales.backOrder.base, {customerId: customerId ?? 0}),
                single: (customerId, orderId) => generatePath(routes.customer.sales.backOrder.single, {
                    customerId: customerId ?? 0,
                    orderId: orderId ?? 0
                }),
            },
            invoices: {
                base: (customerId) => generatePath(routes.customer.sales.invoices.base, {customerId: customerId ?? 0}),
                single: (customerId, orderId) => generatePath(routes.customer.sales.invoices.single, {
                    customerId: customerId ?? 0,
                    orderId: orderId ?? 0
                }),
            },
            credits: {
                base: (customerId) => generatePath(routes.customer.sales.credits.base, {customerId: customerId ?? 0}),
                single: (customerId, orderId) => generatePath(routes.customer.sales.credits.single, {
                    customerId: customerId ?? 0,
                    orderId: orderId ?? 0
                }),
            },
            shoppingCart: (customerId) => generatePath(routes.customer.sales.shoppingCart, {customerId: customerId ?? 0}),
        },
        cardSummary: {
            creditCards: (customerId, id) => generatePath(routes.customer.cardSummary.creditCards, {
                customerId: customerId ?? 0,
                id: id ?? 0
            }),
            giftCards: (customerId, id) => generatePath(routes.customer.cardSummary.giftCards, {customerId: customerId ?? 0, id: id ?? 0}),
        },
        shippingFees: {
            list: (customerId) => generatePath(routes.customer.shippingFees.list, {customerId: customerId ?? 0}),
            settings: (customerId) => generatePath(routes.customer.shippingFees.settings, {customerId: customerId ?? 0}),
        },
        forms: {
            responses: (customerId) => generatePath(routes.customer.forms.responses, {customerId: customerId ?? 0}),
        },
    } as const,
}

/**
 * The Accumulated list of all routes for difference route entries
 */
export const routesLists = {
    all: Utils.flattenObjectAndReturnAsAList(routes),
    allWithServerErrorSection: Utils.flattenObjectAndReturnAsAList(routes, routes.error.serverErrorForSection),
    allWithAccessDeniedSection: Utils.flattenObjectAndReturnAsAList(routes, routes.error.accessDeniedForSection),

    warrantyAndReturnOld: Utils.flattenObjectAndReturnAsAList(routes.warrantyAndReturnOld),
    salesOld: Utils.flattenObjectAndReturnAsAList(routes.salesOld),
    customerSalesOld: Utils.flattenObjectAndReturnAsAList(routes.customerSalesOld),

    auth: Utils.flattenObjectAndReturnAsAList(routes.auth),

    public: Utils.flattenObjectAndReturnAsAList(routes.public),

    lookup: Utils.flattenObjectAndReturnAsAList(routes.lookup),

    warrantyAndReturn: Utils.flattenObjectAndReturnAsAList(routes.warrantyAndReturn),

    customers: Utils.flattenObjectAndReturnAsAList(routes.customers),

    operators: Utils.flattenObjectAndReturnAsAList(routes.operators),

    shippingFees: Utils.flattenObjectAndReturnAsAList(routes.shippingFees),

    accounting: Utils.flattenObjectAndReturnAsAList(routes.accounting),

    content: Utils.flattenObjectAndReturnAsAList(routes.content),

    settings: Utils.flattenObjectAndReturnAsAList(routes.settings),
    taxes: Utils.flattenObjectAndReturnAsAList(routes.settings.taxes),

    giftCards: Utils.flattenObjectAndReturnAsAList(routes.settings.giftCards),

    promotions: Utils.flattenObjectAndReturnAsAList(routes.sales.promotions),

    userPlatform: Utils.flattenObjectAndReturnAsAList(routes.userPlatform),

    customer: {
        generalInformation: Utils.flattenObjectAndReturnAsAList(routes.customer.generalInformation),
        shippingFees: Utils.flattenObjectAndReturnAsAList(routes.customer.shippingFees),
        forms: Utils.flattenObjectAndReturnAsAList(routes.customer.forms),
    } as const,

    print: Utils.flattenObjectAndReturnAsAList(routes.print),
    printWithServerErrorSection: Utils.flattenObjectAndReturnAsAList(routes.print, routes.error.serverErrorForSection),
    printWithAccessDeniedSection: Utils.flattenObjectAndReturnAsAList(routes.print, routes.error.accessDeniedForSection),

    products: Utils.flattenObjectAndReturnAsAList(routes.products),
    productManageSuggestions: Utils.flattenObjectAndReturnAsAList(routes.products.manageSuggestions),
    bulkPriceChange: Utils.flattenObjectAndReturnAsAList(routes.products.bulkPriceChange),

    inventory: Utils.flattenObjectAndReturnAsAList(routes.inventory),
    inventoryAdjustment: Utils.flattenObjectAndReturnAsAList(routes.inventory.inventoryAdjustment),
    inventoryTransfer: Utils.flattenObjectAndReturnAsAList(routes.inventory.inventoryTransfer),

    damageControl: Utils.flattenObjectAndReturnAsAList(routes.damageControl),

    printing: Utils.flattenObjectAndReturnAsAList(routes.printing),

    purchase: Utils.flattenObjectAndReturnAsAList(routes.purchase),

    vendor: Utils.flattenObjectAndReturnAsAList(routes.vendor),
    vendorPurchases: Utils.flattenObjectAndReturnAsAList(routes.vendor.purchases),
    ncr: Utils.flattenObjectAndReturnAsAList(routes.ncr),

    forms: Utils.flattenObjectAndReturnAsAList(routes.forms),

    support: Utils.flattenObjectAndReturnAsAList(routes.support),

    bizPoint: Utils.flattenObjectAndReturnAsAList(routes.bizPoint),
    bizPointLoyalty: Utils.flattenObjectAndReturnAsAList(routes.bizPoint.loyalty),
    bizPointAdmin: Utils.flattenObjectAndReturnAsAList(routes.bizPoint.admin),

    analytics: Utils.flattenObjectAndReturnAsAList(routes.analytics),
    analyticsLogs: Utils.flattenObjectAndReturnAsAList(routes.analytics.logs),
    analyticsLookup: Utils.flattenObjectAndReturnAsAList(routes.analytics.lookup),
    analyticsLostSales: Utils.flattenObjectAndReturnAsAList(routes.analytics.lostSales),
}
